
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locator",
      function () {
        return require("private-next-pages/locator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locator"])
      });
    }
  